var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-test-view":"reviews-cycles-edit-status-participant-edit"}},[_c('l-reviews-cycles-edit-participant-form',{attrs:{"user":_vm.participant,"review-cycle":_vm.reviewCycle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }